/* eslint-disable no-unused-vars */
export enum ActionTypes {
  Loading = 'TRANSLATIONS_LOADING',
  Loaded = 'TRANSLATION_LOADED',
  Failed = 'TRANSLATIONS_FAILED',
  ChangeLanguage = 'CHANGE_LANGUAGE',
  SetLoadingFalse = 'SET_LOADING_FALSE',
}
/* eslint-enable no-unused-vars */

export const DEFAULT_LOCALE = 'en';

export const LOGGER_NAME = 'intl';
